<form [formGroup]="paramFormInclinoV2" *ngIf="!readOnly">
    <mat-form-field>
        <input matInput placeholder="{{'TRIGGER'|translate}}" formControlName="trigger" required type="number">
    </mat-form-field>
</form>

<form *ngIf="readOnly">

    <mat-form-field class="readonly">
        <input matInput placeholder="{{'TRIGGER'|translate}}" [value]="paramFormInclinoV2.value.trigger"
               [readonly]="true">
    </mat-form-field>
</form>
